import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import logo from "../../../images/logo.png";
import { changeFirstLoginPass } from "../../../environment";
import useApi from "../../../core/customhook/useApi";
import Swal from "sweetalert2";
type PasswordField = "password";

const ResetPassword2 = () => {
  const routes = all_routes;
  const location = useLocation();
  const navigation = useNavigate();

  const resetToken = location.state?.resetToken;

  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const setNewPasswordAPI = useApi(changeFirstLoginPass, {
    method: "POST",
    autoCall: false,
    handleGlobalError: false,
  });

  const handleResetPassword = async (
    e: React.MouseEvent<HTMLButtonElement>,
  ) => {
    e.preventDefault();

    try {
      if (!email.trim()) {
        return Swal.fire({
          icon: "warning",
          title: "Email Required",
        });
      }

      if (!newPassword.trim()) {
        return Swal.fire({
          icon: "warning",
          title: "Password Required",
        });
      }

      if (newPassword !== confirmPassword) {
        return Swal.fire({
          icon: "error",
          title: "Passwords do not match",
        });
      }

      const payload = {
        email,
        newPassword,
        resetToken: resetToken,
      };

      const response = await setNewPasswordAPI.callApi(payload);

      if (response?.success) {
        Swal.fire({
          icon: "success",
          title: "Password Changed Successfully",
          text: "Your password has been updated. Please login with your new password.",
          confirmButtonText: "Back to Login",
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then((result) => {
          if (result.isConfirmed) {
            navigation(routes.login);
          }
        });
      } else {
        Swal.fire({
          icon: "error",
          title: response?.error,
        });
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Failed",
        text:
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          "Something went wrong",
      });
    }
  };

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });
  const [password, setPassword] = useState("");
  const [passwordResponce, setPasswordResponce] = useState({
    passwordResponceText:
      "Use 8 or more characters with a mix of letters, numbers, and symbols.",
    passwordResponceKey: "",
  });

  const togglePasswordVisibility = (field: "password" | "confirmPassword") => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const onChangePassword = (password: string) => {
    setPassword(password);
    if (password.match(/^$|\s+/)) {
      setPasswordResponce({
        passwordResponceText: "",
        passwordResponceKey: "",
      });
    } else if (password.length === 0) {
      setPasswordResponce({
        passwordResponceText: "",
        passwordResponceKey: "",
      });
    } else if (password.length < 8) {
      setPasswordResponce({
        passwordResponceText: "Weak. Must contain at least 12 characters",
        passwordResponceKey: "0",
      });
    } else if (
      password.search(/[a-z]/) < 0 ||
      password.search(/[A-Z]/) < 0 ||
      password.search(/[0-9]/) < 0
    ) {
      setPasswordResponce({
        passwordResponceText:
          "Average. Must contain at least 1 upper case and number",
        passwordResponceKey: "1",
      });
    } else if (password.search(/(?=.*?[#?!@$%^&*-])/) < 0) {
      setPasswordResponce({
        passwordResponceText: "Almost. Must contain a special symbol",
        passwordResponceKey: "2",
      });
    } else {
      setPasswordResponce({
        passwordResponceText: "Awesome! You have a secure password.",
        passwordResponceKey: "3",
      });
    }
  };

  return (
    <div className="container">
      <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap">
              <div className="col-md-5 mx-auto vh-100">
                <div className=" mx-auto mb-3 mt-3 text-center">
                  <ImageWithBasePath
                    src={logo}
                    className="img-fluid"
                    alt="Logo"
                  />
                </div>
                <form action="success.html" className="vh-100">
                  <div className="login_form_main d-flex flex-column justify-content-between p-4">
                    <div className="">
                      <div className="text-center mb-3">
                        <h2 className="mb-2">Password Reset</h2>
                        <p className="mb-0">
                          Please set your password as it is mandatory to change
                        </p>
                        <p className="mb-0">
                          after first login for security purpose.
                        </p>
                      </div>
                      <div>
                        <div className="input-block mb-3">
                          <div className="mb-3">
                            <label className="form-label">Email Address</label>
                            <input
                              type="email"
                              className="form-control"
                              placeholder="Enter Email Address"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="input-block mb-3">
                          <div className="mb-3">
                            <label className="form-label">Password</label>
                            <div className="pass-group" id="passwordInput">
                              <input
                                type={
                                  passwordVisibility.password
                                    ? "text"
                                    : "password"
                                }
                                value={newPassword}
                                onChange={(e) => {
                                  setNewPassword(e.target.value);
                                  onChangePassword(e.target.value);
                                }}
                                className="form-control pass-input"
                                placeholder="Enter your password"
                              />
                              <span
                                className={`ti toggle-passwords ${
                                  passwordVisibility.password
                                    ? "ti-eye"
                                    : "ti-eye-off"
                                }`}
                                onClick={() =>
                                  togglePasswordVisibility("password")
                                }
                                style={{ cursor: "pointer" }}
                              ></span>
                            </div>
                          </div>
                          <div>
                            <p
                              className={`m-0 d-flex align-items-center gap-2 ${
                                password.length >= 12 && password.length <= 15
                                  ? "text-success"
                                  : "text-secondary"
                              }`}
                            >
                              <i className="ti ti-check"></i>
                              Min length is 12 and max length is 15.
                            </p>

                            <p
                              className={`m-0 d-flex align-items-center gap-2 ${
                                /[A-Z]/.test(password) && /[a-z]/.test(password)
                                  ? "text-success"
                                  : "text-secondary"
                              }`}
                            >
                              <i className="ti ti-check"></i>
                              At least a uppercase and a lowercase letter.
                            </p>

                            <p
                              className={`m-0 d-flex align-items-center gap-2 ${
                                /[0-9]/.test(password)
                                  ? "text-success"
                                  : "text-secondary"
                              }`}
                            >
                              <i className="ti ti-check"></i>
                              At least include a digit number.
                            </p>

                            <p
                              className={`m-0 d-flex align-items-center gap-2 ${
                                /[#?!@$%^&*-]/.test(password)
                                  ? "text-success"
                                  : "text-secondary"
                              }`}
                            >
                              <i className="ti ti-check"></i>
                              At least a special characters.
                            </p>
                          </div>
                        </div>
                        <p className="fs-12">
                          {passwordResponce.passwordResponceText}
                        </p>
                        <div className="mb-3">
                          <label className="form-label">Confirm Password</label>
                          <div className="pass-group">
                            <input
                              type={
                                passwordVisibility.confirmPassword
                                  ? "text"
                                  : "password"
                              }
                              className="form-control pass-input"
                              placeholder="Confirm Password"
                              value={confirmPassword}
                              onChange={(e) =>
                                setConfirmPassword(e.target.value)
                              }
                            />

                            <span
                              className={`ti toggle-passwords${
                                passwordVisibility.confirmPassword
                                  ? "ti-eye"
                                  : "ti-eye-off"
                              }`}
                              onClick={() =>
                                togglePasswordVisibility("confirmPassword")
                              }
                              style={{ cursor: "pointer" }}
                            ></span>
                          </div>
                        </div>
                        <div className="mb-3">
                          <button
                            type="submit"
                            className="btn btn-primary w-100"
                            onClick={handleResetPassword}
                          >
                            Change Password
                          </button>
                        </div>
                        <p className="text-danger">
                          In case you are facing any issue write to us at{" "}
                          <Link style={{ color: "blueviolet" }} to={"/"}>
                            candidatesupport@aupertz.co.in
                          </Link>
                        </p>
                      </div>
                    </div>
                    {/* <div className="mt-5 pb-4 text-center">
                      <p className="mb-0 text-gray-9">© 2025 Aupterz. All rights reserved.</p>
                    </div> */}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword2;
